module.exports = __webpack_public_path__ + "static/img/al1.e9e5364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al1.jpg
// module id = e4CN
// module chunks = 1